/* eslint-disable import/no-named-as-default */
import React from 'react';
import PropTypes from 'prop-types';

class EquipmentHostIdTextBox extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.handleEquipmentChanged = this
            .handleEquipmentChanged
            .bind(this);
        this.reset = this
            .reset
            .bind(this);
    }
    reset(e) {
        e.preventDefault();
        const {orderId, workOrderActions, outlet} = this.props;
        workOrderActions.outletUpdate({
            orderId: orderId,
            newHostId: outlet.get('originalHostId'),
            outletId: outlet.get('equipmentOutlet')
        });
    }

    handleEquipmentChanged(e) {
        const {orderId, workOrderActions, outlet} = this.props;
        workOrderActions.outletUpdate({
            orderId: orderId,
            newHostId: e.target.value,
            newSerialNumber: outlet.get('serialNumber'),
            outletId: outlet.get('equipmentOutlet')
        });
    }

    render() {
        const {outlet, disabled} = this.props;  

        return (
            <div>
                <label style={{
                    paddingRight: '10px'
                }}>Host Id:
                </label>
                <input
                    disabled={disabled}
                    className="browser-default"
                    value={outlet.get('hostId')}
                    placeholder={'Host Id'}                    
                    onChange={this.handleEquipmentChanged}/></div>
        );
    }
}

EquipmentHostIdTextBox.propTypes = {
    outlet: PropTypes.object,
    orderId: PropTypes.string,
    workOrderActions: PropTypes.object,
    disabled: PropTypes.bool
};
export default EquipmentHostIdTextBox;



// WEBPACK FOOTER //
// ./src/components/equipment/EquipmentHostIdTextBox.js